import { useEffect } from 'react';
import store from './_services/store';
import { getStorageAuthToken, setStorageAuthToken } from './_services/utils/token';
import './App.css';
import AppRouter from './router';
import { StorageService } from './_services/storage';
import { STORAGE_KEYS } from './constants';
import { API_URL_PRD } from './_services/api/config/config';
// Importer les intercepteurs Axios pour gérer les erreurs 401
import './_services/api/interceptors';

// Garde double : ignoré sur tout build qui n'est pas en NODE_ENV=development
// (CRA force NODE_ENV=production sur yarn build → bypass inactif en staging/prod).
const BYPASS_AUTH =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_BYPASS_AUTH === '1';

function App() {
  useEffect(() => {
    (async () => {
      if (BYPASS_AUTH) {
        // Si un vrai token STG est fourni, on l'utilise pour que les appels
        // aux endpoints protégés (molécules, symptômes…) chargent la vraie BDD.
        // Sinon on retombe sur un faux token → pages visibles mais data vide (401).
        const devToken = process.env.REACT_APP_DEV_AUTH_TOKEN;
        if (devToken) {
          console.warn('[DEV] Bypass auth enabled — using real STG auth token.');
          setStorageAuthToken(devToken);
          store.setAuthToken(devToken);
        } else {
          console.warn('[DEV] Bypass auth enabled — no REACT_APP_DEV_AUTH_TOKEN set: mock profile only, protected API calls will 401 (empty data).');
          store.setAuthToken('DEV_BYPASS_TOKEN');
        }
        store.storeProfile({
          key: STORAGE_KEYS.user,
          data: {
            id: 'dev-bypass',
            civility: '1',
            first_name: 'Dev',
            last_name: 'Bypass',
            year: '2020',
            profession: 'Médecine interne',
            email: 'dev@local',
            address: '1 rue du Test',
            zipCode: '75000',
            city: 'Paris',
            professionalid: 'DEV-000',
            auth_mode: 'BYPASS',
          },
        });
        return;
      }

      const lastToken = getStorageAuthToken();
      const lastUser = StorageService.get(STORAGE_KEYS.user);

      if (lastToken) {
        store.setAuthToken(lastToken);
        const data = new URLSearchParams({ token: lastToken });

        fetch(`${API_URL_PRD}/api/public/user/login`, {
          method: 'POST',
          //mode: 'cors',
          body: data,
          //@ts-ignore
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
            "X-PF-Allowed-Proxy": 1,
          },
        })
        .then(res => res.json())
        .then(res => {
          if(res['id'] && res['auth_token']){
            store.storeProfile({key: STORAGE_KEYS.user, data: res})
          }
        }).catch(err => {
          console.log("LOGIN ERR", err);
        })
      }
      else if (lastUser) {
        store.loadUserProfil();
      }
    })()
  }, [])

  return (
    <AppRouter />
  );
}

export default App;


